// import {
//   AccessGroupServiceApiFactory,
//   AmenityServiceApiFactory,
//   ApartmentServiceApiFactory,
//   AuthServiceApiFactory,
//   BuildingServiceApiFactory,
//   DeliveryServiceApiFactory,
//   IntercomDeviceServiceApiFactory,
//   MenuServiceApiFactory,
//   OrgServiceApiFactory,
//   OrgUserServiceApiFactory,
//   RoleServiceApiFactory,
//   RoomServiceApiFactory,
//   S3ServiceApiFactory,
//   SiteServiceApiFactory,
//   TenantServiceApiFactory,
//   UserSelfServiceApiFactory,
//   UserServiceApiFactory,
// } from './autoGenerate/api';
import {
  AccessGroupServiceApiFactory,
  AmenityServiceApiFactory,
  ApartmentServiceApiFactory,
  AuthServiceApiFactory,
  BuildingServiceApiFactory,
  DeliveryServiceApiFactory,
  OrgServiceApiFactory,
  OrgUserServiceApiFactory,
  RoleServiceApiFactory,
  IntercomDeviceServiceApiFactory,
  MenuServiceApiFactory,
  RoomServiceApiFactory,
  S3ServiceApiFactory,
  SiteServiceApiFactory,
  TenantServiceApiFactory,
  UserSelfServiceApiFactory,
  UserServiceApiFactory,
} from './autoGenerate/services';
import apiInstance from './config/axiosConfig';
import axios from 'axios';

export const axiosConfig = {
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 30000,
};

// Create a customized version of authServiceRefresh that uses Authorization header
export const authServiceRefresh = async (refreshToken: string) => {
  const url = `${
    process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/entrio/api'
  }/auth/refresh`;

  try {
    const response = await axios({
      method: 'post',
      url: url,
      headers: {
        Authorization: `Bearer ${refreshToken}`,
      },
    });
    return response;
  } catch (error) {
    console.error('Error refreshing token:', error);
    throw error;
  }
};

export const {
  authServiceLogin,
  authServiceLogout,
  authServiceRegisterCallback,
  authServiceResetPassword,
  authServiceSendForgetPasswordEmail,
  authServiceSendRegisterEmail,
  authServiceVerify,
  authServiceAuthorize,
  authServiceAuthorizeCallback,
  authServiceAuthorizeProvider,
  authServiceDeviceLogin,
  authServiceRegister,
} = AuthServiceApiFactory(undefined, undefined, apiInstance);

export const {
  buildingServiceCreate,
  buildingServiceDelete,
  buildingServiceUpdate,
  buildingServiceDetail,
  buildingServiceFind,
} = BuildingServiceApiFactory(undefined, undefined, apiInstance);

export const {menuServiceFindMenu} = MenuServiceApiFactory(undefined, undefined, apiInstance);

export const {orgServiceFind} = OrgServiceApiFactory(undefined, undefined, apiInstance);

export const {
  roleServiceBindUser,
  roleServiceCreate,
  roleServiceDelete,
  roleServiceDetail,
  roleServiceFind,
  roleServiceGetUsers,
  roleServiceInitDefault,
  roleServiceUnbindUser,
  roleServiceUpdate,
} = RoleServiceApiFactory(undefined, undefined, apiInstance);

export const {
  siteServiceAdd,
  siteServiceDelete,
  siteServiceFindAncestors,
  siteServiceFindDescendants,
  siteServiceList,
  siteServiceMove,
  siteServiceTree,
  siteServiceUpdate,
} = SiteServiceApiFactory(undefined, undefined, apiInstance);

export const {
  userServiceDelete,
  userServiceDetail,
  userServiceFind,
  userServiceUpdate,
  userServiceUpdatePassword,
} = UserServiceApiFactory(undefined, undefined, apiInstance);

export const {
  apartmentServiceCreate,
  apartmentServiceDelete,
  apartmentServiceUpdate,
  apartmentServiceDetail,
  apartmentServiceFind,
} = ApartmentServiceApiFactory(undefined, undefined, apiInstance);

export const {
  intercomDeviceServiceCreate,
  intercomDeviceServiceDelete,
  intercomDeviceServiceDetail,
  intercomDeviceServiceFind,
  intercomDeviceServiceUpdate,
} = IntercomDeviceServiceApiFactory(undefined, undefined, apiInstance);

export const {
  accessGroupServiceSave,
  accessGroupServiceDelete,
  accessGroupServiceDetail,
  accessGroupServiceFind,
  accessGroupServiceAddTenant,
  accessGroupServiceDeleteTenant,
  accessGroupServiceFindTenant,
} = AccessGroupServiceApiFactory(undefined, undefined, apiInstance);

export const {s3ServiceFileObject, s3ServiceGet, s3ServiceTemporarySignUrl} = S3ServiceApiFactory(
  undefined,
  undefined,
  apiInstance
);

export const {
  roomServiceCreate,
  roomServiceDelete,
  roomServiceDetail,
  roomServiceFind,
  roomServiceUpdate,
} = RoomServiceApiFactory(undefined, undefined, apiInstance);

export const {
  amenityServiceCreate,
  amenityServiceDelete,
  amenityServiceDetail,
  amenityServiceFind,
  amenityServiceUpdate,
} = AmenityServiceApiFactory(undefined, undefined, apiInstance);

export const {
  tenantServiceCreate,
  tenantServiceDelete,
  tenantServiceDetail,
  tenantServiceFind,
  tenantServiceUpdate,
  tenantServiceSendInvite,
  tenantServiceSendInviteCallback,
} = TenantServiceApiFactory(undefined, undefined, apiInstance);

export const {
  deliveryServiceCreate,
  deliveryServiceDelete,
  deliveryServiceDetail,
  deliveryServiceFind,
  deliveryServiceUpdate,
} = DeliveryServiceApiFactory(undefined, undefined, apiInstance);

export const {
  orgUserServiceCreate,
  orgUserServiceDelete,
  orgUserServiceDetail,
  orgUserServiceFind,
  orgUserServiceSendInvite,
  orgUserServiceSendInviteCallback,
  orgUserServiceUpdate,
} = OrgUserServiceApiFactory(undefined, undefined, apiInstance);

export const {
  userSelfServiceFindTenants,
  userSelfServiceLogout,
  userSelfServiceMe,
  userSelfServiceOrgFind,
  userSelfServiceWsEcho,
} = UserSelfServiceApiFactory(undefined, undefined, apiInstance);
